import { render } from "./BorderEditSelect.vue?vue&type=template&id=5e2e1046&scoped=true"
import script from "./BorderEditSelect.vue?vue&type=script&lang=js"
export * from "./BorderEditSelect.vue?vue&type=script&lang=js"

import "./BorderEditSelect.vue?vue&type=style&index=0&id=5e2e1046&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5e2e1046"

export default script